import Header from 'semantic-ui-react/dist/commonjs/elements/Header';
import '@purple/semantic-ui-purple-theme/components/header.css';

export default Header;
